import React from 'react';
import Button from 'src/components/common/Button';
import { Input } from 'semantic-ui-react';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import membersForms from 'src/services/api/membersForms';
import { getGuestLeadersColumnDefs } from 'src/components/common/rows/GuestLeadersRow';
import AGTable from 'src/components/table/aggrid';
import styled from '@emotion/styled';
import {
  AdminTableNetworkSection,
  AdminTableContent,
} from 'src/assets/styles/components/AdminTable';
import { crecerClase3ResultsStyles } from 'src/assets/styles/components/clase3Answers';

const CrecerNetworkAdminTable = styled(AdminTableNetworkSection)`
  ${crecerClase3ResultsStyles}
`;

const PER_PAGE = 50;

const GuestLeaders = (props) => {
  const [loaded, set_loaded] = React.useState(true);
  const [totalRecords, set_totalRecords] = React.useState(0);
  const [inputs, setInputs] = React.useState({});

  const gridApiRef = React.useRef(null);
  const filtersRef = React.useRef({});

  const setFilters = () => {
    let filter = {};
    Object.entries(inputs)
      .filter((input) => input[1] != null)
      .forEach((element) => {
        filter[element[0]] = element[1];
      });
    return filter;
  };

  const makeDatasource = () => ({
    getRows: (params) => {
      set_loaded(false);
      const perPage = params.endRow - params.startRow || PER_PAGE;
      const currentPage = Math.floor(params.startRow / perPage) + 1;

      membersForms
        .guestLeaders({ filter: filtersRef.current, currentPage, perPage })
        .then((response) => {
          set_loaded(true);
          if (response.data.success) {
            const rows = response.data.guestLeaders || [];
            const total =
              typeof response.data.total === 'number'
                ? response.data.total
                : params.startRow + rows.length;
            set_totalRecords(total);
            params.successCallback(rows, total);
          } else {
            set_totalRecords(0);
            params.successCallback([], 0);
          }
        })
        .catch((error) => {
          set_loaded(true);
          if (error.response?.status === 404) {
            set_totalRecords(0);
            params.successCallback([], 0);
          } else {
            if (error.response) Swal.fire(error.response.data.message);
            params.failCallback();
          }
        });
    },
  });

  const applyFilters = () => {
    filtersRef.current = setFilters();
    if (gridApiRef.current) {
      gridApiRef.current.setDatasource(makeDatasource());
    }
  };

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    filtersRef.current = setFilters();
    params.api.setDatasource(makeDatasource());
  };

  const onEnter = (e) => {
    if (e.key === 'Enter') applyFilters();
  };

  const handleInputs = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    setInputs({ ...inputs, [name]: value });
  };

  const inputStyles = {
    display: 'inline-block',
    width: '45%',
    margin: ' 7px 0',
  };

  const columnDefs = React.useMemo(() => getGuestLeadersColumnDefs(), []);

  return (
    <CrecerNetworkAdminTable>
      <AdminTableContent>
        <Button text={'Buscar'} onClick={applyFilters} />
        <div>
          <Input
            loading={!loaded}
            name={'keyword'}
            onChange={handleInputs}
            value={inputs.keyword || ''}
            className={'crecerp1c3'}
            style={inputStyles}
            onKeyPress={onEnter}
            placeholder="Buscar por miembro"
          />
          <Input
            loading={!loaded}
            name={'liderKeyword'}
            onChange={handleInputs}
            value={inputs.liderKeyword || ''}
            className={'crecerp1c3'}
            style={inputStyles}
            onKeyPress={onEnter}
            placeholder="Buscar por líder"
          />
        </div>
      </AdminTableContent>
      <div>
        <p>Total de registros: {totalRecords}</p>
        <AGTable
          columnDefs={columnDefs}
          rowModelType="infinite"
          onGridReady={onGridReady}
          pagination
          paginationPageSize={PER_PAGE}
          cacheBlockSize={PER_PAGE}
          rowHeight={60}
          suppressDragLeaveHidesColumns={false}
          defaultCol={{ sortable: false, filter: false, floatingFilter: false }}
        />
      </div>
    </CrecerNetworkAdminTable>
  );
};

export default GuestLeaders;
